import { CourseList, TermList } from '../../../services/student.service.models';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { IStudentAttendances } from "src/app/shared/services/student.service.models";
import { StudentsService } from "src/app/shared/services/students.service";
import { ParentsService } from "src/app/shared/services/parents.service";
import * as moment from 'moment';
import { TourService } from 'ngx-ui-tour-md-menu';
import { MdMenuPlacement } from 'ngx-ui-tour-md-menu';
import { ProfileService } from 'src/app/shared/services/profile.service';
import swal from 'sweetalert'
import { NotificationServices } from 'src/app/shared/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, switchMap } from "rxjs/operators";
import { forkJoin, throwError } from 'rxjs';
import { environment } from "src/environments/environment";
import { LoggingService } from "src/app/shared/services/logging.service";
@Component({
  selector: "app-student-attendance",
  templateUrl: "./student-attendance.component.html",
  styleUrls: ["./student-attendance.component.scss"],
})

export class StudentAttendanceComponent implements OnInit {
  env = environment;
  attendance: any = [];
  fliterTermList:any = [];
  overallAttendanceAvailable = false;
  overallAttendance = null;
  courseList: CourseList[] = [];
  lastUpdated: any;
  summary: boolean = true;
  byDate: boolean = false;
  byCourse: boolean = false;
  selectedTerm: any;
  selectedTermIndex: number;
  dateList = [];
  byCourseList = [];
  student: string;
  isLoading = false;
  attendanceRes: any;
  loadingIndicator = true;
  reorderable = true;
  showCourseSheduleTimeFrame: any;
  displayCourse: boolean = true;
  selectedTermGroups: TermList[] = [];
  byCourseGroups: TermList[] = [];

  columns = [
    { prop: "courseStartDate", name:"Date" },
    { prop: "period", name:"Period" },
    { prop: "courseName", name:"Course Name" },
    { prop: "absence", name:"Absence" },
    { prop: "tardy", name:"Tardy" },
  ];

  constructor(
    private activeRoute: ActivatedRoute,
    private studentService: StudentsService,
    public readonly tourService: TourService,
    private profileService: ProfileService,
    private notificationServices: NotificationServices,
    private toastr: ToastrService,
    private loggingService: LoggingService,
    private parentService: ParentsService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.selectedTermIndex = this.selectedTermIndex || 0;
  
    this.activeRoute.parent.params.pipe(
      switchMap((data) => {
        this.student = data.studentId;
        return forkJoin({
          attendance: this.studentService.getStudentAttendace(data.studentId).pipe(
            catchError(err => {
              console.error('Attendance load error', err);
              return throwError(err);
            })
          ),
          config: this.parentService.getFeatureConfiguration().pipe(
            catchError(err => {
              console.error('Feature config load error', err);
              return throwError(err);
            })
          )
        });
      })
    ).subscribe(({ attendance, config }) => {
      this.isLoading = false;
      this.attendance = attendance;
  
      this.showCourseSheduleTimeFrame = config?.find(x => x.name === 'course_schedule_display_time_frame')?.value;
  
     if (attendance?.termList?.length > 0) {

  this.fliterTermList = attendance.termList.filter(
    (term, index, self) =>
      index === self.findIndex(
        t => t.termName === term.termName
      )
  );

  this.selectedTermIndex = 0;
  this.selectedTerm = this.fliterTermList[0];

  this.setSelectedTermGroups(
    this.selectedTerm.termName
  );

  this.dateList = this.getDateList(attendance.termList);

 this.byCourseGroups = attendance.termList.slice().reverse();
}
  
      this.lastUpdated = moment();
      this.startTour();
  
      // ---overall attendance---
      this.loadIAPAttendance(this.student);
    });
  }  

  displayCourseSchedule(courseStartDate) {  
    const today = new Date();
    
    const [month, day, year] = courseStartDate.split('/').map(Number);
    courseStartDate = new Date(year, month - 1, day);

    const millisecondsInADay = 24 * 60 * 60 * 1000;
    const leadTime = this.showCourseSheduleTimeFrame  * millisecondsInADay;
  
    const displayCourseDate = new Date(courseStartDate.getTime() - leadTime);
  
    if (today >= displayCourseDate) {
      return true;
    } else {
      return false;
    }
  }  

  startTour() {
    let above: MdMenuPlacement = { yPosition: 'above' }
    let below: MdMenuPlacement = { yPosition: 'below' }
    let left: MdMenuPlacement = { xPosition: 'before' }
    let right: MdMenuPlacement = { xPosition: 'after' }

    this.tourService.initialize([
    {
      anchorId: 'start-tour',
      content: 'All attendance updates will be accessible here',
      title: 'Attendance',
    },
    {
      anchorId: 'tab1',
      content: 'You can view an overall summary of them. Click the row to expand further details...',
      title: 'Attendance',
    },
    {
      anchorId: 'tab2',
      content: 'View by Date...',
      title: 'Attendance',
    },
    {
      anchorId: 'tab3',
      content: 'Or view by course',
      title: 'Attendance',
    },
    ]);
    if(this.profileService.profile.hasTour){
      this.tourService.start();
    }
  }

  openTourConfirmation() {
    swal({
      title: `End Tour?`,
      icon: 'warning',
      text: "You can always turn it back on in the Preferences sidebar",
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, turn off tour',
          value: true,
          visible: true,
          closeModal: true
        }
      }
    }).then((res) => {
      if (res) { // OK clicked---
        let userProfile = this.profileService.profile;
        userProfile.hasTour = false;
        this.profileService.saveProfile(userProfile).subscribe(() => {
          this.profileService.getProfile().subscribe(() => {
            this.notificationServices.showSuccessToast(
              "Your profile has been updated"
            );
            window.location.reload();
          });
        });
      }
    });
  }

  getTerm(i) : TermList{
    return this.attendance.termList[i]
  }

  switchTab(tab: string) {
    this.summary = false;
    this.byDate = false;
    this.byCourse = false
    switch (tab) {
      case 'summary':
        this.summary = true;
        break;
      case 'byDate':
        this.byDate = true;
        break;
      case 'byCourse':
        this.byCourse = true;
        break;
    }
  }

  getMarks(course){
    let markList = [];
    if(course.daysAbsent.length > 0){
      _.each(course.daysAbsent, (day)=>{
        day.type = 'Absent';
        markList.push(day)
      })
    }
    if(course.daysTardy.length > 0){
      _.each(course.daysTardy, (day)=>{
        day.type = 'Tardy';
        markList.push(day)
      })
    }
    markList = _.orderBy(markList, ['reasonDate'], ['desc']);
    return markList
  }

  getDateList(termList) {
    let dateList = [];
  
    if (termList.length > 0) {
      _.each(termList, (term) => {
        if (term.courseList.length > 0) {
          _.each(term.courseList, (course) => {
            if (this.displayCourseSchedule(course.courseStartDate)) {
              if (course.daysAbsent.length > 0) {
                _.each(course.daysAbsent, (day) => {
                  day.type = 'Absent';
                  day.course = course.courseName;
                  dateList.push(day);
                });
              }
  
              if (course.daysTardy.length > 0) {
                _.each(course.daysTardy, (day) => {
                  day.type = 'Tardy';
                  day.course = course.courseName;
                  dateList.push(day);
                });
              }
            }
          });
        }
      });
    }
  
    dateList = _.orderBy(dateList, ['reasonDate'], ['asc']);
    return dateList;
  }

  getCourseList(termList){
    let courseList = [];
    if(termList.length > 0){
      _.each(termList, (term) => {
        if(term.courseList.length > 0) {
          _.each(term.courseList, (course) => {
            courseList.push(course)
          })
        }
      })
    }
    courseList = this.orderCourseList(courseList);
    return courseList
  }

  changeTerm(term) {
  this.selectedTermIndex = term;

  this.selectedTerm = this.fliterTermList[term];

  this.setSelectedTermGroups(this.selectedTerm.termName);
}

  orderCourseList(courseList) {
    courseList = _.orderBy(courseList, ['period'], 'asc')
      .filter(course => this.displayCourseSchedule(course.courseStartDate));  
    return courseList; 
  }  

  loadIAPAttendance(studentId) {      
    if (this.env.enableIAP) {
      this.studentService.getStudentIAPAttendace(studentId).subscribe(
        (attendance) => {
          if (attendance.error == "") {
            this.overallAttendance = attendance;
            this.overallAttendance.color = "overall-attendance " + this.overallAttendance.color;
            this.overallAttendanceAvailable = true;
          }
        }        
      );
    }      
  }

  openAttendanceLink(url) {
    //this.loggingService.insertLogging(this.student, 'Student Attendance Link');
    if (url != "")
      window.open(url, "_blank");
  }
  setSelectedTermGroups(termName: string) {
  this.selectedTermGroups = this.attendance.termList
    .filter(term => term.termName === termName)
    .slice()
    .reverse();
}
}
